<script setup>
import { socialShareImage, usePageHead } from '@composables/use-page-head'
import { computed, onMounted, ref, watch } from 'vue'
import { useAppearanceStore } from '@stores/appearance'
import { useScrollContainer } from '@composables/use-scroll-container'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

const LIMIT = 30
const BOTTOM_OFFSET_RATIO = 3

const appearanceStore = useAppearanceStore()
const scrollContainer = useScrollContainer()

const mixes = ref([])
const offset = ref(0)
const isFull = ref(false)
const isLoading = ref(false)

const scroll = computed(() => appearanceStore.scroll)

function loadMixes(from) {
    isLoading.value = true
    DataLayer.mixes.getLatest(LIMIT, from).then(response => {
        if (!response.body.length) {
            isFull.value = true
        } else {
            mixes.value.push(...response.body)
        }
        isLoading.value = false
    })
}

watch(scroll, () => {
    if (isFull.value || isLoading.value) return

    const bottomOfWindow =
        scroll.value + window.innerHeight >=
        scrollContainer.value.offsetHeight - window.innerHeight / BOTTOM_OFFSET_RATIO

    if (bottomOfWindow) {
        offset.value += LIMIT
        loadMixes(offset.value)
    }
})

onMounted(() => {
    loadMixes(offset.value)
})

usePageHead({
    title: 'Latest Mixes',
    description: `The newest DJ mixes from FRISKY's resident DJs and global guests.`,
    image: socialShareImage(),
})
</script>

<template>
    <BaseSection
        v-if="mixes && mixes.length"
        padded
    >
        <MixGridBlock :mixes="mixes" />
    </BaseSection>
</template>
